import { getFirAuth } from '../../Api/firebase/firebaseConnect'

/**
 * Configure Firebase Auth for development mode to bypass reCAPTCHA verification
 * This allows testing phone authentication without solving reCAPTCHA challenges
 */
export const configureFirebaseForDevelopment = async (): Promise<void> => {
  if (process.env.NODE_ENV !== 'development') return

  try {
    const auth = await getFirAuth()
    if (auth) {
      const host = window?.location?.hostname
      const isLocal = host === 'localhost' || host === '127.0.0.1'
      if (!isLocal) return
      ;(auth as any).settings = (auth as any).settings || {}
      ;(auth as any).settings.appVerificationDisabledForTesting = true
    }
  } catch (err) {
    console.warn('Could not configure Firebase for development:', err)
  }
}

/**
 * Get appropriate timeout for phone verification
 */
export const getPhoneVerificationTimeout = (defaultTimeout: number): number => {
  return process.env.NODE_ENV === 'development' ? 30000 : defaultTimeout
}
